export default __webpack_public_path__ + "static/media/genes.c3d57a1f.png";